import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ApiError } from "@/lib/apiClient";
import { fetchGuestMobileSession } from "@/lib/guestTabletApi";
import type { GuestTabletMobileSession } from "@/types/guestTablet";
import { TabletGuestGuide } from "./components/TabletGuestGuide";
import { TabletUpselling } from "./components/TabletUpselling";
import { TabletWeatherProgram } from "./components/TabletWeatherProgram";
import { TabletWelcome } from "./components/TabletWelcome";
import "./guest-tablet.css";

export function GuestMobilePage() {
  const { token = "" } = useParams<{ token: string }>();
  const [data, setData] = useState<GuestTabletMobileSession | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    void fetchGuestMobileSession(token)
      .then(setData)
      .catch((err) => {
        setError(err instanceof ApiError ? err.message : "Link ungültig.");
      })
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <div className="guest-tablet-root">
      <div className="guest-tablet-shell space-y-6">
        {loading && <p className="py-12 text-center">Wird geladen…</p>}
        {error && <p className="guest-tablet-card p-4 text-red-700">{error}</p>}
        {data && (
          <>
            <TabletWelcome welcome={data.welcome} isDemo={false} />
            <TabletGuestGuide sections={data.guest_guide} />
            <TabletWeatherProgram weather={data.weather} program={data.daily_program} />
            <TabletUpselling offers={data.upselling} />
          </>
        )}
      </div>
    </div>
  );
}
